import { RegisterLifterCompetitionTypeSelect } from './register-result-competition-type';
import { RegisterLifterAgeCategorySelect } from './register-result-age-category';
import { useFilterForm } from '~/hooks/useFilterForm';
import { Table } from '~/components/Table/Table';
import { querySchema } from '../query-schema';

export function RegistrationListFilter() {
  const { register, setValue, values } = useFilterForm(querySchema.parse);

  return (
    <Table.Bar>
      <Table.Search {...register('search')} placeholder="Sök på lyftare..." />

      <RegisterLifterCompetitionTypeSelect
        {...register('competition_type_id')}
        onChange={event => setValue('competition_type_id', event.target.value)}
        defaultValue={values.competition_type_id}
      />

      <RegisterLifterAgeCategorySelect
        {...register('age_category_id')}
        onChange={event => setValue('age_category_id', event.target.value)}
        defaultValue={values.age_category_id}
      />
    </Table.Bar>
  );
}
